<div class="accordion-container">
  <div class="no-data" *ngIf="isRoadmapsEmpty()">
    {{ 'no_data_available' | translate }}
  </div>
  <ng-container *ngIf="!isRoadmapsEmpty()">
    <div cdkDropList (cdkDropListDropped)="drop($event)">
      <div *ngFor="let item of roadmaps; trackBy: trackByRoadmap" class="roadmap-item-container" cdkDrag>
        <img cdkDragHandle
            src="../../../assets/icon/reorder.svg" 
            alt="drag"
            class="drag-handle"
            tooltip="{{ 'Drag to reorder' | translate }}"
            placement="top">              
        <div class="accordion-wrapper">
          <div class="accordion-item">
            <div
              class="accordion-item-header"
              [ngClass]="{'active': item.active }"
              tabindex="0"
              role="button"
              [attr.aria-expanded]="item.active"
              (click)="toggleAccordion(item)"
              (keydown.enter)="onAccordionHeaderEnter($event, item)">
              <input *ngIf="showCheckbox" type="checkbox" class="custom-checkbox"
                [class.indeterminate-state]="item?.indeterminate"
                [ngClass]="{ 'hidden': item?.bodyItems?.length == 0 }" [(ngModel)]="item.selected"
                [indeterminate]="item?.indeterminate"
                (change)="toggleAllSelections(item, $event)"
                (click)="$event.stopPropagation()"
                (keydown.enter)="onCheckboxEnter($event)">
              <span class="head-text">{{ item.roadmap_name }} <span *ngIf="item?.version !== 'NA' && item?.roadmap_version !== 'NA' ">({{item?.version ? item?.version : item?.roadmap_version}})</span></span>
              <div *ngIf="item?.selectedQuestions" [ngClass]="{'sub-details': showStatusBox}" class="selected-question-count">
                <span>{{ item?.selectedQuestions }} {{ 'Question(s) Selected' | translate }}</span>
              </div>
              <div
                class="yes-compliant-toggle"
                tabindex="0"
                role="switch"
                [attr.aria-checked]="item?.includeYesCompliantSection"
                [attr.aria-disabled]="item?.isYesCompliantToggleDisabled"
                [tooltip]="(item?.includeYesCompliantSection ? 'INCLUDE_YES_COMPLIANT_SECTION_TOOLTIP' : 'EXCLUDE_YES_COMPLIANT_SECTION_TOOLTIP') | translate"
                (click)="handleIncludeYesCompliantTap(item, $event)"
                (keydown.enter)="onYesCompliantToggleKeydown(item, $event)"
                (keydown.space)="onYesCompliantToggleKeydown(item, $event)"
                placement="top">
                <ion-toggle
                  mode="md"
                  [checked]="item?.includeYesCompliantSection"
                  [disabled]="item?.isYesCompliantToggleDisabled"
                  (ionChange)="toggleIncludeYesCompliant(item, $event)">
                </ion-toggle>
              </div>
              <button
                type="button"
                class="accordion-arrow-button"
                [attr.aria-expanded]="item.active"
                [attr.aria-label]="item.active ? ('Collapse roadmap' | translate) : ('Expand roadmap' | translate)"
                (click)="onAccordionArrowClick(item, $event)">
                <img
                  [src]="item.active ? '../../../assets/icon/up-arrow.svg' : '../../../assets/icon/down-arrow.svg'"
                  [alt]="item.active ? 'Collapse roadmap' : 'Expand roadmap'"
                  class="accordion-arrow-icon">
              </button>
            </div>
            <div class="accordion-item-body" [class.active]="item.active" [attr.aria-hidden]="!item.active">
              <div class="accordion-item-body-content">
                <div class="no-body-data" *ngIf="item?.bodyItems?.length == 0">
                  {{'no_data_available' | translate}}
                </div>
                <div *ngFor="let subItem of item.bodyItems; trackBy: trackByBodyItem">
                  <div class="checkbox-container">
                    <div class="left-align">
                      <input *ngIf="showCheckbox" type="checkbox" class="custom-checkbox" [(ngModel)]="subItem.selected"
                      [attr.tabindex]="item.active ? null : -1"
                      (change)="toggleBodyItemSelection(subItem, item); updateHeaderCheckbox(item)"
                      (keydown.enter)="onCheckboxEnter($event)">
                      <label for="checkbox" class="parent-item-label">{{ subItem.text }}</label>
                    </div>
                  </div>
                  <div *ngIf="subItem.subItems" class="sub-items">
                    <div *ngFor="let nestedSubItem of subItem.subItems; trackBy: trackByNestedBodyItem">
                      <div class="checkbox-container">
                        <div class="left-align">
                          <input *ngIf="showCheckbox" type="checkbox" class="custom-checkbox" [(ngModel)]="nestedSubItem.selected"
                          [attr.tabindex]="item.active ? null : -1"
                          (change)="updateHeaderCheckbox(item)"
                          (keydown.enter)="onCheckboxEnter($event)">
                          <div class="label-with-note">
                            <label #childItemLabel for="checkbox" class="child-item-label" [tooltip]="isTextTruncated(childItemLabel) ? nestedSubItem.text : null" placement="top">{{ nestedSubItem.text }}</label>
                            <ion-icon *ngIf="nestedSubItem.notes" class="note-icon" tooltip={{nestedSubItem.notes}} placement="right"
                              name="information-circle">
                            </ion-icon>
                          </div>
                        </div>
                        <div class="right-align">
                          <span class="roadmap-type" [ngClass]="{
                            'compliant': nestedSubItem.compliant,
                            'hazard': nestedSubItem.hazard,
                            'not-applicable': nestedSubItem.not_applicable,
                            'not-compliant': nestedSubItem.notcompliant
                          }">{{nestedSubItem.compliant ? ('Compliant' | translate) : nestedSubItem.hazard ? ('Hazard'| translate) :
                            nestedSubItem.not_applicable ? ('Not Applicable' | translate) : nestedSubItem.notcompliant ? ('Not Compliant' | translate) : '' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="history-button-container">
          <button
            type="button"
            class="history-icon-button"
            (click)="getRoadmapHistory($event, item)"
            tooltip="{{ 'History' | translate }}"
            placement="left">
            <span class="history-label">{{ 'History' | translate }}</span>
            <img src="assets/icon/History_icon.svg" [attr.alt]="'History' | translate" class="history-icon">
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>

